// extracted by mini-css-extract-plugin
export default {"root":"_2hgaI","feedback":"_1bH3Q","error":"_2f1PD","open":"Duj6M"};